import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import Goo from "gooey-react";

export default class Services extends React.Component {
    render() {
        return (
            <div>
                <Navigation/>

                <section className="hero-wrap hero-wrap-2" style={{backgroundImage: 'url("images/place-4.jpg")'}}
                         data-stellar-background-ratio="3">
                    <div className="overlayy1"/>
                    <div className="container">
                        <div
                            className="row no-gutters slider-text js-fullheight align-items-center justify-content-center">
                            <div className="col-md-9 ftco-animate pb-0 text-center">
                                {/* <p className="breadcrumbs"><span className="mr-2"><a href="/">Home <i className="fa fa-chevron-right"></i></a></span> <span>Services <i className="fa fa-chevron-right"></i></span></p> */}
                                <h1 className="mb-3 bread">Services</h1>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="ftco-section ftco-no-pb ftco-no-pt bg-primary">
                    <div className="container">
                        <div className="row d-flex no-gutters">
                            <div className="col-md-3 d-flex align-items-stretch ftco-animate">
                                <div className="media block-6 services services-bg d-block text-center px-4 py-5">
                                    <div className="icon d-flex justify-content-center align-items-center">
                                        <span className="flaticon-business"/></div>
                                    <div className="media-body py-md-4">
                                        <h3>Trusted by Thousands</h3>
                                        <p>A small river named Duden flows by their place and supplies it with the
                                            necessary
                                            regelialia.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 d-flex align-items-stretch ftco-animate">
                                <div
                                    className="media block-6 services services-bg services-darken d-block text-center px-4 py-5">
                                    <div className="icon d-flex justify-content-center align-items-center"><span
                                        className="flaticon-home"/></div>
                                    <div className="media-body py-md-4">
                                        <h3>Wide Range of Properties</h3>
                                        <p>A small river named Duden flows by their place and supplies it with the
                                            necessary
                                            regelialia.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 d-flex align-items-stretch ftco-animate">
                                <div
                                    className="media block-6 services services-bg services-lighten d-block text-center px-4 py-5">
                                    <div className="icon d-flex justify-content-center align-items-center"><span
                                        className="flaticon-stats"/></div>
                                    <div className="media-body py-md-4">
                                        <h3>Financing Made Easy</h3>
                                        <p>A small river named Duden flows by their place and supplies it with the
                                            necessary
                                            regelialia.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 d-flex align-items-stretch ftco-animate">
                                <div className="media block-6 services services-bg d-block text-center px-4 py-5">
                                    <div className="icon d-flex justify-content-center align-items-center"><span
                                        className="flaticon-quarantine"/></div>
                                    <div className="media-body py-md-4">
                                        <h3>Locked in Pricing</h3>
                                        <p>A small river named Duden flows by their place and supplies it with the
                                            necessary
                                            regelialia.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="ftco-section services-section bg-darken" id="workflow">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-12 text-center heading-section heading-section-white ftco-animate">
                                <span className="subheading">Work flow</span>
                                <h2 className="mb-3">How it works</h2>
                            </div>
                        </div>
                        <div className="row">

                            <div className="col-lg-3 col-md-3 col-sm-3  p-3">
                                <div style={{position:"relative",width:"150px",marginLeft:"52px"}}>
                                    <Goo intensity={"medium"}>

                                        <svg style={{animation:" 9s linear 0s infinite normal none running rotate_back"}} width="200">

                                            <circle cx="50%" cy="50%" r="50" fill="#2a9d48"
                                                    style={{animation: "12s ease-in-out -3s infinite alternate none running blob_four"}}></circle>
                                            <circle cx="50%" cy="50%" r="36" fill="#2a9d48"
                                                    style={{animation: "9s ease-in-out -3s infinite alternate none running blob_three"}}></circle>
                                            <circle cx="50%" cy="50%" r="30" fill="#2a9d48"
                                                    style={{animation: "6s ease-in-out -3s infinite alternate none running blob_two"}}></circle>
                                            <circle cx="50%" cy="50%" r="34" fill="#2a9d48"
                                                    style={{animation: "3s ease-in-out -3s infinite alternate none running blob_one"}}></circle>

                                        </svg>

                                    </Goo>
                                </div>
                                <div className="icon mb-1 d-flex align-items-center justify-content-center" style={{position:'absolute',top:"50%",left:"50%",transform:"translate(-50%,-100px)"}}>
                                    <span className="text-white font-weight-bold" style={{fontSize:"24px"}}>01</span>
                                    {/*<img src="images/blob.svg" alt=""/>*/}
                                </div>
                                <h3 className="text-white text-center">Evaluate Property</h3>
                                <p className="text-center">A small river named Duden flows by their place and supplies it with the necessary
                                    regelialia.</p>


                            </div>

                            <div className="col-lg-3 col-md-3 col-sm-3  p-3">
                                <div style={{position:"relative",width:"150px",marginLeft:"52px"}}>
                                    <Goo intensity={"medium"}>

                                        <svg style={{animation:" 9s linear 0s infinite normal none running rotate_back"}} width="200">

                                            <circle cx="50%" cy="50%" r="50" fill="#2a9d48"
                                                    style={{animation: "12s ease-in-out -3s infinite alternate none running blob_four"}}></circle>
                                            <circle cx="50%" cy="50%" r="36" fill="#2a9d48"
                                                    style={{animation: "9s ease-in-out -3s infinite alternate none running blob_three"}}></circle>
                                            <circle cx="50%" cy="50%" r="30" fill="#2a9d48"
                                                    style={{animation: "6s ease-in-out -3s infinite alternate none running blob_two"}}></circle>
                                            <circle cx="50%" cy="50%" r="34" fill="#2a9d48"
                                                    style={{animation: "3s ease-in-out -3s infinite alternate none running blob_one"}}></circle>

                                        </svg>

                                    </Goo>
                                </div>
                                <div className="icon mb-1 d-flex align-items-center justify-content-center" style={{position:'absolute',top:"50%",left:"50%",transform:"translate(-50%,-100px)"}}>
                                    <span className="text-white font-weight-bold" style={{fontSize:"24px"}}>02</span>
                                    {/*<img src="images/blob.svg" alt=""/>*/}
                                </div>
                                <h3 className="text-white text-center">Meet Your Agent</h3>
                                <p className="text-center">A small river named Duden flows by their place and supplies it with the necessary
                                    regelialia.</p>


                            </div>

                            <div className="col-lg-3 col-md-3 col-sm-3  p-3">
                                <div style={{position:"relative",width:"150px",marginLeft:"52px"}}>
                                    <Goo intensity={"medium"}>

                                        <svg style={{animation:" 9s linear 0s infinite normal none running rotate_back"}} width="200">

                                            <circle cx="50%" cy="50%" r="50" fill="#2a9d48"
                                                    style={{animation: "12s ease-in-out -3s infinite alternate none running blob_four"}}></circle>
                                            <circle cx="50%" cy="50%" r="36" fill="#2a9d48"
                                                    style={{animation: "9s ease-in-out -3s infinite alternate none running blob_three"}}></circle>
                                            <circle cx="50%" cy="50%" r="30" fill="#2a9d48"
                                                    style={{animation: "6s ease-in-out -3s infinite alternate none running blob_two"}}></circle>
                                            <circle cx="50%" cy="50%" r="34" fill="#2a9d48"
                                                    style={{animation: "3s ease-in-out -3s infinite alternate none running blob_one"}}></circle>

                                        </svg>

                                    </Goo>
                                </div>
                                <div className="icon mb-1 d-flex align-items-center justify-content-center" style={{position:'absolute',top:"50%",left:"50%",transform:"translate(-50%,-100px)"}}>
                                    <span className="text-white font-weight-bold" style={{fontSize:"24px"}}>03</span>
                                    {/*<img src="images/blob.svg" alt=""/>*/}
                                </div>
                                <h3 className="text-white text-center">Close The Deal</h3>
                                <p className="text-center">A small river named Duden flows by their place and supplies it with the necessary
                                    regelialia.</p>


                            </div>

                            <div className="col-lg-3 col-md-3 col-sm-3  p-3">
                                <div style={{position:"relative",width:"150px",marginLeft:"52px"}}>
                                    <Goo intensity={"medium"}>

                                        <svg style={{animation:" 9s linear 0s infinite normal none running rotate_back"}} width="200">

                                            <circle cx="50%" cy="50%" r="50" fill="#2a9d48"
                                                    style={{animation: "12s ease-in-out -3s infinite alternate none running blob_four"}}></circle>
                                            <circle cx="50%" cy="50%" r="36" fill="#2a9d48"
                                                    style={{animation: "9s ease-in-out -3s infinite alternate none running blob_three"}}></circle>
                                            <circle cx="50%" cy="50%" r="30" fill="#2a9d48"
                                                    style={{animation: "6s ease-in-out -3s infinite alternate none running blob_two"}}></circle>
                                            <circle cx="50%" cy="50%" r="34" fill="#2a9d48"
                                                    style={{animation: "3s ease-in-out -3s infinite alternate none running blob_one"}}></circle>

                                        </svg>

                                    </Goo>
                                </div>
                                <div className="icon mb-1 d-flex align-items-center justify-content-center" style={{position:'absolute',top:"50%",left:"50%",transform:"translate(-50%,-100px)"}}>
                                    <span className="text-white font-weight-bold" style={{fontSize:"24px"}}>04</span>
                                    {/*<img src="images/blob.svg" alt=""/>*/}
                                </div>
                                <h3 className="text-white text-center">Have Your Property</h3>
                                <p className="text-center">A small river named Duden flows by their place and supplies it with the necessary
                                    regelialia.</p>


                            </div>


                        </div>
                    </div>
                </section>

                <section className="ftco-section" id="services">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-12 text-center heading-section ftco-animate mb-5">
                                <span className="subheading">Services</span>
                                <h2 className="mb-3">Our Services</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 d-flex align-items-stretch ftco-animate">
                                <div className="media block-6 services d-block text-center px-3 pb-4">
                                    <div className="icon d-flex justify-content-center align-items-center"><span
                                        className="flaticon-home-repair"/></div>
                                    <div className="media-body py-md-4">
                                        <h3>Real Estate Developers </h3>
                                        {/* className="text-left more" */}
                                        <p>
                                            Having more than 30 years of experience, we gained a great goodwill in the
                                            market as a leading Developers in the industry in Punjab. We have a team of
                                            experienced professionals and skilled workers who work dedicatedly so as to
                                            delivery high quality & modern solutions. We make use of the best in line
                                            manpower and material resources for our projects. We are here to help you
                                            land,
                                            determine the marketing strategy, develop the building program and design,
                                            obtain the necessary public approval and financing, build the structures,
                                            and
                                            rent out, manage, and ultimately sell it. <br/>
                                            <br/>

                                            We have a team of expert architects, city planners, engineers, contractors &
                                            lawyers working with us and supervising every step along the way!
                                            <br/>
                                            <br/>


                                            Our experience and links in the industry help us actualize plans from paper
                                            to
                                            reality.


                                        </p>


                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 d-flex align-items-stretch ftco-animate">
                                <div className="media block-6 services d-block text-center px-3 pb-4">
                                    <div className="icon d-flex justify-content-center align-items-center"><span
                                        className="flaticon-sales"/></div>
                                    <div className="media-body py-md-4">
                                        <h3>Real Estate Consultants</h3>
                                        <p>We offer real estate consulting services to our clients across the globe. We
                                            offer our clients outstanding services such as acquiring and exploring land,
                                            discussing various investment alternative, getting the best deals, getting
                                            suitable clients, assisting in process buying and selling of the property,
                                            Construction Services, Renovation Services and Property Insurance Services.
                                            Along with that, we also take care that everything is being done
                                            lawfully. <br/>
                                            <br/>

                                            We are committed to fully understanding the specific needs of every
                                            individual
                                            client and strategically find personalized solutions. This ensures that our
                                            clients are able to make informed real estate decisions, reduce costs and
                                            risks,
                                            create value and get the growth they aspired for.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 d-flex align-items-stretch ftco-animate">
                                <div className="media block-6 services d-block text-center px-3 pb-4">
                                    <div className="icon d-flex justify-content-center align-items-center"><span
                                        className="flaticon-bank"/></div>
                                    <div className="media-body py-md-4">
                                        <h3>Construction Services </h3>
                                        <p>We are offering reliable Construction Services for different type of
                                            Residential
                                            & Commercial projects. We understand the requirement of the clients and
                                            provide
                                            affordable world-class Construction Solutions with high quality standards
                                            and
                                            modern architecture. Before the commencement of construction, our experts do
                                            perform an inspection of the site to be sure about the techniques and legal
                                            procedures involved in the construction. We use the finest quality raw
                                            material
                                            to ensure that the constructed buildings and structures are durable and have
                                            the
                                            strength to withstand harsh weather condition. We aim to deliver a quality
                                            product to our clients at the promised time. We ensure there are no
                                            unneccary
                                            delays in product delivery.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 d-flex align-items-stretch ftco-animate">
                                <div className="media block-6 services d-block text-center px-3 pb-4">
                                    <div className="icon d-flex justify-content-center align-items-center"><span
                                        className="flaticon-team"/></div>
                                    <div className="media-body py-md-4">
                                        <h3>Renovation Services in Jalandhar</h3>
                                        <p>Renovating your aleady existing home is more challenging than creating a new
                                            house all together. You need to create a new structure from an already
                                            existing
                                            unit by salvaging the best features of the current unit and adding modern
                                            architecture to it within in a fixed budget.
                                            <br/>

                                            For the convenience of the esteemed clients, we offer remarkable Renovation
                                            Services. We have with us experienced and skilled workers who understand the
                                            requirement of the client and work accordingly.
                                            <br/><br/>
                                            We work within the client budget to turn their real estate dreams into
                                            reality.
                                            We use only the finest quality raw material to ensure the best services are
                                            provided along with durable renovation. We offer our services at an
                                            affordable
                                            price to the clients and make sure that they do not face any problem.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 d-flex align-items-stretch ftco-animate">
                                <div className="media block-6 services d-block text-center px-3 pb-4">
                                    <div className="icon d-flex justify-content-center align-items-center"><span
                                        className="flaticon-home-repair"/></div>
                                    <div className="media-body py-md-4">
                                        <h3>Real Estate Contractors </h3>
                                        <p>As reliable developers, builders and colonisers, we have a goodwill in the
                                            industry. We provide our services as a reliable Real Estate Contractors. We
                                            provide skilled labor on contract basis. Masons, Painters, Plumbers,
                                            Electrician
                                            and Carpenters are made available by us to the clients on contractual basis.
                                            The
                                            skilled labor will ensure that the particular work is accomplished within
                                            given
                                            timeframe. We are committed to provide 100% satisfaction to clients by
                                            showing
                                            our perfection and excellence in the work we do. If you are looking for any
                                            sort
                                            of construction that you want to give it on a contract, then, you can avail
                                            our
                                            hassle free services.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 d-flex align-items-stretch ftco-animate">
                                <div className="media block-6 services d-block text-center px-3 pb-4">
                                    <div className="icon d-flex justify-content-center align-items-center"><span
                                        className="flaticon-sales"/></div>
                                    <div className="media-body py-md-4">
                                        <h3>Real Estate Legal Consultancy</h3>
                                        <p>Real Estate is an industry which needs big investments which in turn get
                                            bigger
                                            returns. To reduce risk, it is best to work within the legal framework of
                                            the
                                            country. We thereby provide reliable Property Legal Consultancy to our
                                            clients
                                            globally. We assist our clients in all sorts of legal matters. We have
                                            experienced legal advisors with us, who have expertise in handling Property
                                            Documentation, Property Law Services, and Property Litigation. We can easily
                                            resolve and provide solutions for all sorts of real estate disputes.Our
                                            service
                                            charges are very nominal and we offer prompt services to our clients in
                                            least
                                            possible time.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 d-flex align-items-stretch ftco-animate">
                                <div className="media block-6 services d-block text-center px-3 pb-4">
                                    <div className="icon d-flex justify-content-center align-items-center"><span
                                        className="flaticon-bank"/></div>
                                    <div className="media-body py-md-4">
                                        <h3>
                                            Real Estate Loan Consultancy
                                        </h3>
                                        <p>Being licensed real estate developers, we are one of the prominent Real
                                            Estate
                                            Loan Consultants. We work in close network with reputed banks, both
                                            government &
                                            private, like Capital Bank, HDFC and PNB etc, so that you can easily get
                                            financial assistance. We help our clients in getting different variety of
                                            financial aid & loans such as Residential Property Loan, Commercial Property
                                            Loan, Home Loan, and Loan against Property. We also try to get you the
                                            benefits
                                            of the latest government schemes. We try to bag subsidies wherever possible
                                            for
                                            our clients. Our expert employees provide assistance to the clients in
                                            understanding the entire loan process.<br/><br/>

                                            If you are facing problem in getting financial assistance, then you can
                                            avail
                                            our hassle free services at affordable prices. It is our responsibility to
                                            get
                                            you financial aid in a stipulated time frame and we make sure that you do
                                            not
                                            have to run around to get your loan passed.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 d-flex align-items-stretch ftco-animate">
                                <div className="media block-6 services d-block text-center px-3 pb-4">
                                    <div className="icon d-flex justify-content-center align-items-center"><span
                                        className="flaticon-team"/></div>
                                    <div className="media-body py-md-4">
                                        <h3> Real Estate Insurance Services</h3>
                                        <p>Securing you real estate investments is a must. They are costly investments
                                            and
                                            must properly be safeguarded. We offer our clients with the outstanding
                                            Property
                                            Insurance Services that protect them for unforeseeable risks. Some risks are
                                            always involved so it is always better take precautions in the starting
                                            phase
                                            only. We offer our clients with the different types of insurance policies at
                                            the
                                            suitable prices. The policies offered by us are very comprehensive and
                                            include
                                            major claims like fire breakage, natural furies, any accidents, etc. The
                                            process
                                            is very simple. We make sure that clients do not face any problem in
                                            claiming if
                                            any unfortunate event occurs in their property.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer/>
            </div>
        );
    }
}